function toQueryString(params?: Record<string, string>) {
  const searchParams = new URLSearchParams(params);
  const searchParamsString = searchParams.toString();

  return searchParamsString ? `?${searchParamsString}` : "";
}

export { toQueryString };
